import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { orgQueryKeys } from './organizations'
import type { QueryOptions } from './types'
import { Organization } from '../schemas'



// Organization mutation hooks (for future use)

// Hook for getting cached organization data without triggering a request
export function useOrganizationCache(id: string | null | undefined): Organization | undefined {
  const queryClient = useQueryClient()
  
  if (!id) return undefined
  
  return queryClient.getQueryData<Organization>(orgQueryKeys.detail(id))
}

// // Advanced hook that combines list and individual org fetching
// export function useOrganizationsWithSelected(
//   listParams: GetOrganizationsParams = {},
//   selectedOrgId: string | null = null,
//   options: QueryOptions = {}
// ) {
//   const organizationsQuery = useOrganizations(listParams, options)
//   const selectedOrgQuery = useOrganization(selectedOrgId, options)
  
//   return {
//     organizations: organizationsQuery,
//     selectedOrg: selectedOrgQuery,
//     isLoading: organizationsQuery.isLoading || selectedOrgQuery.isLoading,
//     hasError: organizationsQuery.isError || selectedOrgQuery.isError,
//     error: organizationsQuery.error || selectedOrgQuery.error,
//   }
// } 
